export default __webpack_public_path__ + "static/media/passport.5db33c70.png";